import axios from 'axios';

export const cmsOperationMiddleware = store => next => action => {
  // Proceed with the action as usual
  const result = next(action);

  // Check if the dispatched action is a CMS operation
  if (
    action.type.includes('UPDATE') ||
    action.type.includes('DELETE') ||
    action.type.includes('CREATE') ||
    action.type.includes('UPLOAD') ||
    action.type.includes('ADD') ||
    action.type.includes('SEND_PHOTOS') ||
    action.type.includes('REMOVE') ||
    action.type.includes('CHANGE')
  ) {
    // Perform the API call for revalidation
    axios
      .get(
        'https://bel-fast-site.vercel.app/api/revalidate?secret=b4f5a8e2d1c73fb9qSotUooy0ar&tag=all'
      )
      .then(response => {
        console.log('CMS revalidated successfully', response);
      })
      .catch(error => {
        console.error('CMS revalidation failed', error);
      });
  }

  return result;
};
